export function isNullOrUndefinedOrBlank(value: any): boolean {
  if (value === '') {
    return true;
  }

  if (value === null) {
    return true;
  }

  if (value === undefined) {
    return true;
  }

  return false;
}
